export const oneLine = (text: string): string => {
  return text.replace(/[^\S\n]*\n\s*/g, ' ');
};
